// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-modal-container[data-v-25543ed8]{background-color:var(--panel-background);border-radius:var(--panel-border-radius);box-shadow:var(--panel-shadow);height:80vh;max-height:50rem;max-width:80rem;position:relative;transition:transform .3s ease,opacity .3s ease;width:70vw}@media(max-width:1024px){.video-modal-container[data-v-25543ed8]{height:100vh;width:100vw}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
